import { all, takeEvery, put, fork, call } from 'redux-saga/effects'
import actions from './actions'
import AxiosInterceptor from "../../Services/examinterceptor";

const fetchExamDetails = async (payload) => {
  const { url } = payload
  const result = await AxiosInterceptor.get(url)
  return result
}

export function* getDetailsSaga() {
  yield takeEvery(actions.GET_DETAILS_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(fetchExamDetails, payload)
      if (res.data.status_code==1) {
        yield put({
          type: actions.GET_DETAILS_SUCCESS,
          examDetails: res.data,
        })
      }
    } catch (error) {
      yield put({
        type: actions.GET_DETAILS_ERROR,
        error: error.message,
      })
    }
  })
}

export default function* rootSaga() {
  yield all([fork(getDetailsSaga)])
}
